import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewRef } from '@angular/core'
import { JSONRpcResponse } from '../../../../Interfaces/JSONRpcResponse'
import { FormulaireService, StateService } from '../../../../services'

import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS
} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { LOCALE_ID } from '@angular/core';

@Component({
	selector: 'atyl-historique-listing',
	templateUrl: './historique-listing.component.html',
	styleUrls: ['./historique-listing.component.scss'],
	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
		{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
export class HistoriqueListingComponent implements OnInit {

	@Output() valueReplaced: EventEmitter<any> = new EventEmitter(null);
	@Input() forminput: any
	@Input() disabled: boolean=false
		
	dossier: any
	active: boolean = false;
	historique: any[] = [];
	constructor(
		private formulaireService: FormulaireService,
		private stateService: StateService,
		private changeDetectorRef: ChangeDetectorRef
	) { }

	ngOnInit() {
		this.stateService.dossier.subscribe((dossier: any) => {
			if (dossier) {
				this.dossier = dossier
				this.active = this.dossier.tiers ? true : false
				setTimeout(() => {
					if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
						this.changeDetectorRef.detectChanges()
					}
				})
			}
		})
	}
	replaceValue(value: any) {
		this.valueReplaced.emit(value)
	}

	populateMenuItems(event: MouseEvent) {
		if (this.historique.length == 0) {
			this.formulaireService.v3_getChampsHistorique(this.forminput.ID, this.dossier.tiers.ID).subscribe((res: JSONRpcResponse) => {
				this.historique = res.result[0]
				setTimeout(() => {
					if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
						this.changeDetectorRef.detectChanges()
					}
				})
			})
		}
	}

}
